module.exports = __webpack_public_path__ + "static/media/15C.b6694018.png";